import { render, staticRenderFns } from "./PromotionPopup.vue?vue&type=template&id=32598740&scoped=true&"
import script from "./PromotionPopup.vue?vue&type=script&lang=js&"
export * from "./PromotionPopup.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPopup.vue?vue&type=style&index=0&id=32598740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32598740",
  null
  
)

export default component.exports